import type { MessageKey, Translate } from '@/i18n';
import type { HubCategory } from '@/types';

const CATEGORY_KEYS: Record<string, MessageKey> = {
  live: 'category.live',
  slot: 'category.slot',
  slots: 'category.slot',
  instant: 'category.instant',
  table: 'category.table',
};

/** Category ids are stable; their upstream labels are English-only. */
export function categoryLabel(t: Translate, category: HubCategory): string {
  const key = CATEGORY_KEYS[String(category.id).toLowerCase()];
  return key ? t(key) : category.label;
}

/** Products the header advertises, in the order the landing site lists them. */
export const HEADER_CATEGORIES: Array<{ id: string; key: MessageKey }> = [
  { id: 'live', key: 'nav.liveCasino' },
  { id: 'slot', key: 'nav.slots' },
  { id: 'table', key: 'nav.tableGames' },
];
